import React from 'react'
import { Link } from 'react-router-dom'

class Home extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="base-width">

      </div>
    )
  }
}

export default Home;


// WEBPACK FOOTER //
// ./app/javascript/app/pages/home/index.jsx